/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdhocForm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8.9 22 6 19l2.9-3 1.4 1.4L8.8 19l1.6 1.6zM4 21H2V7h2zm16-1h-2v-2h2zm-3 0h-2v-2h2zm-3 0h-2v-2h2zm6-3h-2v-2h2zm0-3h-2v-2h2zm.6-3.6L19 8.8l-1.6 1.6L16 8.9 19 6l3 2.9zM4 5H2V2h2zm17-1H6V2h15z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgAdhocForm as AdhocForm };
